export default __webpack_public_path__ + "static/media/10.2a2f530f.jpg";